import React, { useState } from "react";
import HelperString from 'utils/helper-string'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import i18n from 'utils/i18n'
import Form, { createTranslationField } from 'components/molecules/Form'
import _ from 'lodash'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { FormFieldsConstants } from 'utils/constants/form-constants'

const EmailData = ({ email, saveForm }) => {
	
	const [ formKey, setFormKey ] = useState( HelperString.random() )
	
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const formFields = [
		{
			name: 'type',
			label: i18n.t('management:form.type.title'),
			type: FormFieldsConstants.SELECT,
			options: [
				{
					value: 'booking_noshow',
					label: i18n.t( 'management:form.type.booking_noshow')
				},
			]
		},
		{
			name: 'time',
			label: i18n.t('management:form.time.title'),
			type: FormFieldsConstants.TIME
		},
		//{
		//	name: 'for_date',
		//	label: i18n.t('management:form.for_date.title'),
		//	type: FormFieldsConstants.DATE_PICKER
		//},
		{
			name: 'active',
			label: i18n.t('management:form.active.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		}
	];
	
	// Add the translations
	if( _.size( _languages ) > 0 ) {
		// Add the translation fields
		_.forEach( _languages, ( language ) => {
			
			const languageContents = _.find( email.contents ?? [], ( o => {
				return o.language.code === language.code
			}) );
			
			formFields.push( {
				type: FormFieldsConstants.DIVIDER
			} );
			
			_.forEach([ 'subject', 'content'], field => {
				const { name, formField } = createTranslationField( field, language );
				formFields.push({
					...formField,
					type: field !== 'content' ? FormFieldsConstants.TEXT : FormFieldsConstants.TEXT_AREA,
					props: field !== 'content' ? {} : {
						numberOfLines: 20
					},
				});
				
				if( !_.isEmpty( languageContents ) ) {
					email[ name ] = languageContents?.[ field ] ?? '';
				}
			})
		});
	}
	
	return (
		<ThemedBlock
			header={ i18n.t('management:form_block.title_default') }
			shadow
			mediumPadding>
			
			{/* Form */}
			<Form
				key={ HelperString.hash( 'form', formKey ) }
				values={ email }
				fields={ formFields }
				onSubmit={ saveForm }
				disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.SETTINGS ) }
			/>
		</ThemedBlock>
	)
}

export default EmailData
